import { NavArrowDownSolid, NavArrowUpSolid } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { TABLE_ORDER } from './TableContent.types';

interface TableOrderProps {
  order: TABLE_ORDER;
}

const TableOrder: FunctionComponent<TableOrderProps> = ({ order }) => (
  <>
    {order === TABLE_ORDER.ASC && <NavArrowUpSolid width={15} height={15} />}
    {order === TABLE_ORDER.DESC && <NavArrowDownSolid width={15} height={15} />}
  </>
);

export default TableOrder;
